<template>
	<div class="independent-wrapper">
		<div class="content" ref="box">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 客户管理 > 机构管理
			</div>
			<div class="contentLeft">
				<div class="tab-container tab">
					<ul>
						<li v-for="(item, index) in tabList" :key="index" :class="{ active: currentTabIndex == index }"
							@click="goOther(index)">
							{{ item }}
						</li>
					</ul>
				</div>
				<div class="con">
					<div class="search-con">
						<el-form :inline="true" :model="searchData" class="demo-form-inline">
							<el-form-item class="el-form-item-line " label="机构">
								<el-select v-model="searchData.hos" placeholder="请选择机构">
									<el-option v-for="item in hosOptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item class="el-form-item-line " label="用户姓名">
								<el-input v-model="searchData.name" placeholder="请输入用户姓名查询"></el-input>
							</el-form-item>
							<el-form-item class="el-form-item-line " label="手机号码">
								<el-input v-model="searchData.phone" placeholder="请输入手机号码查询"></el-input>
							</el-form-item>
							<el-form-item class="el-form-item-line " label="所在省市">
								<el-cascader v-model="selectedOptions" @change="handleChange"
									:props="{label: 'label',value: 'label'}" :options="proCityOptions"></el-cascader>
							</el-form-item>
							<el-form-item class="el-form-item-line " label="是否购买">
								<el-select v-model="searchData.buy" placeholder="请选择">
									<el-option v-for="item in whetherBuyOptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item class="el-form-item-line date" label="测量时间">
								<el-form-item class="line" prop="startDate">
									<el-date-picker size="large" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
										placeholder="开始日期" v-model="searchData.startDate"></el-date-picker>
								</el-form-item>
								<span class="line line-10">-</span>
								<el-form-item class="line endDate" prop="endDate">
									<el-date-picker size="large" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="结束日期"
										v-model="searchData.endDate"></el-date-picker>
								</el-form-item>
							</el-form-item>

							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-button size="large" :icon="RefreshRight" @click="reset">重置</el-button>
								<el-button size="large" :icon="Search" class="searchBtn" @click="onSearch">查询</el-button>
								<el-button size="large" type="primary" :icon="Plus" @click="addHos">新增</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="table-con consiliaTable">
						<el-table ref="multipleTable" :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
							tooltip-effect="dark" style="width: 100%;cursor: pointer;"
							@selection-change="handleSelectionChange" :data="tableListData" @cell-click="viewReport">
							<!-- <el-table-column type="selection" width="50">
          </el-table-column> -->
							<el-table-column align="center" label="编码" prop="number">
							</el-table-column>
							<el-table-column align="center" label="姓名" prop="name" width="80">
							</el-table-column>
							<el-table-column align="center" label="手机号" prop="phone">
								<template #default="{row}">
									<div>
										{{ row.phone ? row.phone : "暂无" }}
									</div>
								</template>
							</el-table-column>
							<el-table-column align="center" label="脉象结果" prop="pulse">
								<template #default="{row}">
									<div v-html="row.pulse"></div>
								</template>
							</el-table-column>
							<el-table-column align="center" label="测量时间" prop="visitTime">
							</el-table-column>
							<el-table-column align="center" label="操作" width="100">
								<span class="editor">
									查看报告
								</span>
							</el-table-column>
						</el-table>
						<div class="des">
							<div class="right">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange"
										:current-page="currentPage" :page-size="10"
										layout="prev, pager, next, jumper" :total="total">
									</el-pagination>
								</div>
								<div class="data">
									共<span>{{ totalPage }}</span>页/<span>{{ total }}</span>条记录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="dialog">
			<el-dialog :title="addOrEdit == 'add' ? '新增机构' : '编辑机构'" v-model="addUserFlag" center>
				<div class="con">
					<el-form ref="addUserForm" :model="addUserForm" :rules="rules" label-width="80px">
						<div class="item">
							<div class="line">
								<el-form-item class="el-form-item-line" label="客户名称" prop="name">
									<el-input class="longInput" v-model="addUserForm.name"></el-input>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="关联公司" prop="affiliate">
									<el-input class="longInput" v-model="addUserForm.affiliate"></el-input>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="客户类型" prop="customType">
									<el-select :disabled="addOrEdit == 'edit'" v-model="addUserForm.customType"
										placeholder="请选择类型">
										<el-option v-for="(item, index) in customTypeList" :key="index"
											:label="item.label" :value="item.label">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="客户阶段" prop="customStage">
									<el-select :disabled="addOrEdit == 'edit'" v-model="addUserForm.customStage"
										placeholder="请选择类型">
										<el-option v-for="(item, index) in customStageList" :key="index"
											:label="item.label" :value="item.label">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="联系人" prop="contacts">
									<el-input class="longInput" v-model="addUserForm.contacts"></el-input>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="联系电话" prop="phone">
									<el-input class="longInput" v-model="addUserForm.phone"></el-input>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="职务" prop="title">
									<el-input class="longInput" v-model="addUserForm.title"></el-input>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="地区" prop="area">
									<el-cascader v-model="selectedproCityArea" @change="handleproCityArea" :props="{label: 'label',value: 'label'}"
										:options="proCityAreaOptions"></el-cascader>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="详细地址" prop="address">

									<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" class="longInput"
										v-model="addUserForm.address"></el-input>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="购买数量" prop="num">
									<el-input class="longInput" v-model="addUserForm.num"></el-input>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="微信号" prop="weixin">
									<el-input class="longInput" v-model="addUserForm.weixin"></el-input>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="qq" prop="qq">
									<el-input class="longInput" v-model="addUserForm.qq"></el-input>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="邮箱" prop="email">
									<el-input class="longInput" v-model="addUserForm.email"></el-input>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="备注信息" prop="notes">
									<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" class="longInput"
										v-model="addUserForm.notes"></el-input>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</div>
				
				<template class="dialog-footer" #footer>
					<el-button size="large" @click="cancelPatient">取 消</el-button>
					<el-button size="large" class="addBtn" type="primary" @click="addPatient('addUserForm')">确 定</el-button>
				</template>
			</el-dialog>
		</div>

	</div>
</template>
<script>
	import globle from "../../globle/globle";
	import { RefreshRight,Search,Plus } from '@element-plus/icons-vue'
	import {
		provinceAndCityData,
		regionData,
		CodeToText
	} from 'element-china-area-data'
	export default {
		data() {
			return {
				RefreshRight,
				Search,
				Plus,
				searchData: {
					hos: "", //机构
					name: "", //
					phone: "", //医案分类
					buy: "", //软件版本
					startDate: "", //开始日期
					endDate: "", //结束日期
				},
				tabList: ["用户管理", "机构管理"],
				currentTabIndex: 1,
				role: "",
				currentPage: 1, //当前页
				totalPage: 1, //总页数
				total: 1, //总数据
				tableListData: [],
				scroll: 0,
				hosOptions: [{
						value: '-1',
						label: '请选择'
					},
					{
						value: '0',
						label: '机构1'
					},
					{
						value: '1',
						label: '机构2'
					}
				],
				whetherBuyOptions: [{
						value: '-1',
						label: '请选择'
					},
					{
						value: '0',
						label: '是'
					},
					{
						value: '1',
						label: '否'
					}
				],
				proCityOptions: provinceAndCityData,
				proCityAreaOptions: regionData,
				selectedOptions: [],
				customTypeList: [{
						label: '经销商',
						value: '经销商'
					},
					{
						label: '代理商',
						value: '代理商'
					},
					{
						label: '合作伙伴',
						value: '合作伙伴'
					},
					{
						label: '普通用户',
						value: '普通用户'
					},
					{
						label: '其他',
						value: '其他'
					}
				],
				customStageList: [{
						label: '售前跟踪',
						value: '售前跟踪'
					},
					{
						label: '合同执行',
						value: '合同执行'
					},
					{
						label: '售后服务',
						value: '售后服务'
					},
					{
						label: '合同期满',
						value: '合同期满'
					}
				],
				addUserForm: {
					name: '', //客户姓名
					affiliate: '', //关联公司
					customType: '', //客户类型
					customStage: '', //客户阶段
					contacts: '', //联系人
					phone: '', //联系电话
					title: '', //职务
					area: '', //地区
					address: '', //详情地址
					notes: '', //备注信息
					num:'',
					weixin:'',
					qq:'',
					email:'',
					id: "",
				},
				rules: {
					name: [{
						required: true,
						message: "请输入客户姓名",
						trigger: "blur",
					}],
					contacts: [{
						required: true,
						message: "请输入联系人",
						trigger: "blur",
					}],
					phone: [{
						required: true,
						message: "请输入联系电话",
						trigger: "blur",
					}],
					area: [{
						required: true,
						message: "请选择省市区",
						trigger: "blur",
					}]
				},
				addOrEdit: "",
				addUserFlag: false,
				selectedproCityArea: []
			};
		},

		methods: {
			//路由切换
			goOther(index) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/userManagement/userManagement",
					});
				}
				if (index == 1) {
					this.$router.push({
						path: "/userManagement/insManagement",
					});
				}
			},
			//重置
			reset() {
				this.searchData = {
					startDate: "", //开始日期
					endDate: "", //结束日期
					name: "", //
					code: "", //西医诊断
					phone: "", //医案分类
					email: "", //分享范围
				};
				this.gethistroyList();
			},

			//搜索功能
			onSearch() {
				if (this.searchData.endDate < this.searchData.startDate) {
					alert("结束时间不能小于开始时间");
					return false;
				}
				this.currentPage = 1;
				this.gethistroyList();
			},

			addHos() {
				this.addUserFlag = true;
				this.addOrEdit = "add";
				this.$nextTick(() => {
					this.$refs.addUserForm.clearValidate();
				});
			},


			//获取历史列表
			gethistroyList() {
				this.$applicationJson("/business/pulse/result/paging", {
						current: this.currentPage,
						orderBy: "",
						params: {
							number: this.searchData.code,
							patientName: this.searchData.name,
							phone: this.searchData.phone,
							statDateL: this.searchData.startDate,
							statDateR: this.searchData.endDate,
							pulse: this.searchData.pulse,
						},
						size: 10,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							this.total = res.data.data.total;
							this.totalPage = res.data.data.pages;
						} else {
							alert(res.data.msg);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//页码跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				this.gethistroyList();
			},

			//选中的列表
			handleSelectionChange() {},

			viewReport() {
				this.$router.push({
					path: "/userManagement/insManagementDetail"
				});
			},

			handleChange(value) {
				this.selectedOptions = value
			},
			//省市区
			handleproCityArea(value) {
				this.selectedproCityArea = value
				this.addUserForm.area = this.selectedproCityArea.join(',')
				console.log(this.addUserForm.area)
			},
			//确定
			addPatient(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert(1)
					} else {
			  	console.log("error submit!!");
						return false;
					}
				});
			},
			//取消
			cancelPatient() {
				this.addUserFlag = false;
			},

		},
		created() {
			this.$nextTick(() => {
				let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				let role = loginInfo.role;
				this.role = role;

				this.gethistroyList();
			});
		},
		activated() {
			this.$refs.box.scrollTop = this.scroll;
		},
		
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		.content {

			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);

				.demo-form-inline {
					margin-top: 10px;
				}

				.search-con {
					@media screen and (min-width: 0px) and (max-width: 1060px) {
						height: 240px;
						width: 100%;
					}

					@media screen and (min-width: 1060px) and (max-width: 1280px) {
						height: 180px;
						width: 100%;
					}

					@media screen and (min-width: 1280px) and (max-width: 1335px) {
						height: 180px;
						width: 100%;
					}

					@media screen and (min-width: 1340px) and (max-width: 1480px) {
						height: 120px;
						width: 100%;
					}

					@media screen and (min-width: 1480px) and (max-width: 1856px) {
						height: 120px;
						width: 100%;
					}

					@media (min-width: 1920px) {
						width: 100%;
						height: 120px;
					}
				}
			}

		}

		.editor {
			cursor: pointer;
			color: #679ff6;
		}
	}

	.dialog {
		:deep(.el-dialog__body){
			padding: 0;

			.con {
				margin-top: 30px;
				padding: 0 5px;
				width: calc(100% - 10px);
				overflow-y: auto;
				padding-bottom: 30px;
				min-height: 500px;

				.item {
					.line {
						width: 100%;
						overflow: hidden;

						&:nth-child(1) {
							margin-bottom: 20px;
						}

						.el-form-item {
							width: 100%;
						}

						.dosageIcon {
							font-size: 16px;
							color: #666;
							margin-left: 10px;
							cursor: pointer;
						}

						.dialog-tit {
							height: 40px;
							line-height: 40px;

							span {
								float: left;
								font-size: 16px;
								margin-bottom: 20px;
								overflow: hidden;
								width: 100%;
								color: #333;
							}

							.border {
								background-color: rgba(103, 159, 246, 1);
								width: 3px;
								height: 14px;
								margin-top: 13px;
								position: absolute;
								left: 0px;
							}
						}
					}
				}
				.el-form-item-line {
					width: 100% !important;
				
					.el-select {
						width: 100% !important;
					}
				
					.el-input,
					.el-textarea {
						width: 96% !important;
					}
				
					.el-input__inner {
						width: 100% !important;
					}
				}
				.longInput {
					width: 100%;

					:deep(.el-input__inner){
						width: 100% !important;
					}
					
				}
				.el-select,.el-cascader{
					width: 100%;
					:deep(.el-input__inner){
						width: 100% !important;
					}
				}
				.smallInput {
					width: 150px;

					:deep(.el-input__inner){
						width: 100%;
					}
				}
			}
		}
	}
</style>
